import React from 'react';
import styles from './LoadingBlock.scss';
export var LoadingBlock = function LoadingBlock(props) {
  var variant = props.variant,
      className = props.className;
  var variantStyles = styles[variant];
  return React.createElement("div", {
    className: "".concat(styles.loadingBlock, " ").concat(variantStyles, " ").concat(className),
    "data-test": props.dataTest
  }, React.createElement("div", {
    className: styles.background
  }));
};
LoadingBlock.defaultProps = {
  className: '',
  dataTest: 'loading-block',
  variant: 'default'
};